import { mapGetters } from 'vuex'
import i18n from '@/locales'
import { WORKFLOW_TYPES } from '@/constants/workflow'

export default {
  computed: mapGetters(['isAdminMode', 'l3PermissionEnable']),
  created () {
    this.singleActions = [
      {
        label: i18n.t('system.text_225'),
        permission: 'process_manage_update',
        action: (obj) => {
          this.createDialog('DisableDialog', {
            title: i18n.t('system.text_225'),
            name: i18n.t('system.text_12'),
            columns: this.columns,
            data: [obj],
            alert: i18n.t('system.text_552'),
            ok: async () => {
              try {
                let response = {}
                if (obj.type === 'service_desk') {
                  response = await this.changeExtraProcessDefinitionsStatus(obj, 'activate')
                } else {
                  response = await this.onManager('batchUpdate', {
                    id: [obj.id],
                    managerArgs: {
                      data: {
                        state: 'activate',
                        'process-key': obj.key,
                      },
                    },
                  })
                }
                this.refresh()
                this.$store.dispatch('app/fetchWorkflowEnabledKeys')
                return response
              } catch (error) {
                throw error
              }
            },
          })
        },
        meta: (obj) => {
          const ret = { validate: obj.suspended }
          if (obj.key === WORKFLOW_TYPES.APPLY_MACHINE || obj.key === WORKFLOW_TYPES.APPLY_SERVER_CHANGECONFIG) {
            ret.validate = false
            ret.tooltip = i18n.t('system.workflow_create_server_tip')
          }
          return ret
        },
      },
      {
        label: i18n.t('system.text_226'),
        permission: 'process_manage_update',
        action: (obj) => {
          this.createDialog('DisableDialog', {
            title: i18n.t('system.text_226'),
            name: i18n.t('system.text_12'),
            columns: this.columns,
            data: [obj],
            alert: i18n.t('system.text_553'),
            ok: async () => {
              try {
                let response = {}
                if (obj.type === 'service_desk') {
                  response = await this.changeExtraProcessDefinitionsStatus(obj, 'suspend')
                } else {
                  response = await this.onManager('batchUpdate', {
                    id: [obj.id],
                    managerArgs: {
                      data: {
                        state: 'suspend',
                        'process-key': obj.key,
                      },
                    },
                  })
                }
                this.refresh()
                this.$store.dispatch('app/fetchWorkflowEnabledKeys')
                return response
              } catch (error) {
                throw error
              }
            },
          })
        },
        meta: (obj) => ({
          validate: !obj.suspended,
        }),
      },
      {
        label: i18n.t('system.text_548'),
        permission: 'process_manage_create',
        action: (obj) => {
          this.createDialog('WorkflowConfigUpdateProcessDialog', {
            vm: this,
            data: [obj],
            columns: this.columns,
            onManager: this.onManager,
            refresh: this.refresh,
          })
        },
        meta: (obj) => {
          const ret = { validate: obj.can_update }
          if (obj.key === WORKFLOW_TYPES.APPLY_MACHINE || obj.key === WORKFLOW_TYPES.APPLY_SERVER_CHANGECONFIG) {
            ret.validate = false
            ret.tooltip = i18n.t('system.workflow_create_server_tip')
          }
          return ret
        },
      },
    ]
  },
}
